(function() {
  if (typeof theme === 'undefined') return;
  theme.inlineNavigationCheck = function() {
    var pageHeader = document.querySelector('.pageheader');
    if (!pageHeader) return;
    var inlineNavContainer = pageHeader.querySelector('.logo-area__left__inner');
    var inlineNav = inlineNavContainer && inlineNavContainer.querySelector('.navigation--left');
    if (!inlineNav || getComputedStyle(inlineNav).display === 'none') return;
    var inlineMenuCentered = document.querySelector('.pageheader--layout-inline-menu-center');
    var logoContainer = document.querySelector('.logo-area__middle__inner');
    var firstInlineNavLink = inlineNav.querySelector('.navigation__item:first-child');
    var lastInlineNavLink = inlineNav.querySelector('.navigation__item:last-child');
    var rightEl = document.querySelector('.logo-area__right__inner');
    var logoArea = document.querySelector('.logo-area');
    if (!logoArea) return;
    var rightWidth = rightEl ? rightEl.clientWidth : 0;
    var middleWidth = logoContainer ? logoContainer.clientWidth : 0;
    var computedLogoAreaStyle = getComputedStyle(logoArea);
    var logoAreaInnerWidth = logoArea.clientWidth - Math.ceil(parseFloat(computedLogoAreaStyle.paddingLeft)) - Math.ceil(parseFloat(computedLogoAreaStyle.paddingRight));
    var availableNavWidth = logoAreaInnerWidth - Math.max(rightWidth, middleWidth) * 2 - 40;
    var inlineNavWidth = 0;
    var navContainerWidth = inlineNavContainer.offsetWidth;
    if (lastInlineNavLink && firstInlineNavLink) {
      inlineNavWidth = document.querySelector('html[dir=rtl]')
        ? firstInlineNavLink.offsetLeft - lastInlineNavLink.offsetLeft + firstInlineNavLink.offsetWidth
        : lastInlineNavLink.offsetLeft - firstInlineNavLink.offsetLeft + lastInlineNavLink.offsetWidth;
    }
    var tallLogo = logoContainer && lastInlineNavLink && logoContainer.clientHeight > lastInlineNavLink.clientHeight + 20;
    var permitInline = lastInlineNavLink && navContainerWidth >= inlineNavWidth;
    if (inlineMenuCentered && logoContainer) {
      inlineNavContainer.style.maxWidth = availableNavWidth + 'px';
    }
    if (lastInlineNavLink) {
      if (permitInline) {
        pageHeader.classList.add('pageheader--layout-inline-permitted');
        inlineNav.classList.toggle('navigation--tight-underline', !!tallLogo);
      } else {
        pageHeader.classList.remove('pageheader--layout-inline-permitted');
      }
    }
  };
  theme.setInitialHeaderHeightProperty = function() {
    var section = document.querySelector('.section-header');
    if (!section) return;
    requestAnimationFrame(function() {
      var h = section.clientHeight;
      document.documentElement.style.setProperty('--theme-header-height', Math.ceil(h) + 'px');
    });
  };
})();
